import Vue from 'vue';
import { AuthProvider } from '../providers/auth.provider';

export const HideForRoleDirective = Vue.directive('hide-for-role', {
  bind(el, binding, vnode) {
    const roles: string[] = binding.value;

    const isUserAllowed = AuthProvider.isUserAllowed(roles);

    if (!isUserAllowed) {
      el.innerHTML = '';
    }
  },
});